import { render, staticRenderFns } from "./duplicateLisacomunicaTemplateModal.vue?vue&type=template&id=6991fcd9&"
import script from "./duplicateLisacomunicaTemplateModal.vue?vue&type=script&lang=js&"
export * from "./duplicateLisacomunicaTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports